export const URL_DASHBOARD = "/dashboard";
export const URL_TEAM = "/my-team";
